import axios from 'axios';
import analytics from 'shared/utility/analytics';

export const getToolSettings = async setBroken => {
  const response = await axios.get('/woningwaarde/tool-settings').catch(() => setBroken(true));
  const { uaCode } = response.data;
  analytics.init('G-SKVYBL3GJ2', uaCode);
  return response?.data;
};

export const reducer = (state, { key, value }) => {
  return { ...state, [key]: value };
};
